import axios from '@/core/axios';
import { CatalogEntry, CatalogFilters, CatalogOptions } from './devices-catalog.types';

class DevicesCatalogService {
  list(filters: CatalogFilters = {}): Promise<CatalogEntry[]> {
    return axios.get<CatalogEntry[]>('/devices/sellable-catalog', { params: filters }).then(resp => resp?.data || []);
  }

  options(): Promise<CatalogOptions> {
    return axios.get<CatalogOptions>('/devices/sellable-catalog/options').then(resp => resp?.data);
  }
}

export const devicesCatalogService = new DevicesCatalogService();
